export enum CoverageType {
  Covered = 200000000,
  NotCovered = 200000001,
  PaidInFull = 200000002,
}

export enum Unit {
  Amount = 'Amount',
  VAmount = 'VAmount',
  Business = 'Business',
  CabinClass = 'Cabin Class',
  CoPay = 'Co-Pay',
  Days = 'Days',
  Economy = 'Economy',
  Events = 'Events',
  Months = 'Months',
  Nights = 'Nights',
  Percentage = 'Percentage',
  PrimaryUnit = 'Primary Unit',
  RoomType = 'Room Type',
  SemiPrivateRoom = 'Semi-private room',
  StandardPrivateOrSemiPrivateRoom = 'Standard Private or Semi-Private room',
  SuperiorPrivateRoom = 'Superior private room',
  Visits = 'Visits',
  Years = 'Years',
}

export enum UnitGroup {
  Visit = 'Visit',
  Night = 'Night',
  FlightTicket = 'Flight Ticket',
  Day = 'Day',
  Money = 'Money',
  Amount = 'Amount',
  CabinClass = 'Cabin Class',
  Nights = 'Nights',
  Visits = 'Visits',
  Days = 'Days',
  CoPay = 'co-pay',
  RoomType = 'Room Type',
  Percentage = 'Percentage',
  Months = 'Months',
  Years = 'Years',
  Events = 'Events',
  PrimaryUnit = 'Primary Unit',
  Age = 'Age',
}

export enum ActionId {
  openSobDialog = 'open-sob-dialog',
  openPolicyDialog = 'open-policy-dialog',
  viewMembershipCard = 'view-membership-card',
}
